// extracted by mini-css-extract-plugin
export var dividerLine = "_8b-3";
export var itemImage = "_8b-9";
export var lightDivider = "_8b-4";
export var modalContent = "_8b-5";
export var modalContentCompact = "_8b-6";
export var productCard = "_8b-a";
export var productImage = "_8b-b";
export var productImageCompact = "_8b-7";
export var productImagePlaceholder = "_8b-c";
export var productImagePlaceholderCompact = "_8b-8";
export var progressBarBackground = "_8b-1";
export var progressBarContainer = "_8b-0";
export var progressBarFill = "_8b-2";